module.exports = __webpack_public_path__ + "static/work-screentime-0ccd6c616d21b7645f39bc3cf1297322.png";